import * as React from 'react';
import { MessageBar, styled, concatStyleSetsWithProps, mergeStyles, Link } from '@fluentui/react';
import { getFFXHostUxIcon } from '@fluidx/icons/lib/useIconNames/ffxHostUx';
const dismissIcon = {
    iconName: getFFXHostUxIcon('FFXCancel')
};
export const messageBannerTitleTestId = 'messageBannerTitleTestId';
const BaseMessageBanner = (props)=>{
    const { bannerStrings , actions , icon: messageBarIcon , messageBarType , isMultiline , isAssertive , styles , onDismiss , dismissButtonAriaLabel , hyperlink  } = props;
    // a11y: use assertive banners
    const assertiveBanner = isAssertive ? 'alert' : undefined;
    // a11y: use polite banners in non-assertive cases
    const politeBanner = assertiveBanner ? undefined : 'polite';
    const { root , content , text , titleText , messageText , actionStyles , iconStyles: messageBarIconStyles , dismissal  } = concatStyleSetsWithProps(props, styles);
    return /*#__PURE__*/ React.createElement(MessageBar, {
        styles: {
            root,
            content,
            text,
            actions: actionStyles,
            dismissal
        },
        messageBarType: messageBarType,
        isMultiline: isMultiline,
        tabIndex: 0,
        ariaLabel: bannerStrings.bannerMessage,
        role: assertiveBanner,
        "aria-live": politeBanner,
        messageBarIconProps: {
            iconName: messageBarIcon,
            styles: messageBarIconStyles
        },
        dismissIconProps: dismissIcon,
        actions: actions ? /*#__PURE__*/ React.createElement(React.Fragment, null, actions) : undefined,
        onDismiss: onDismiss,
        dismissButtonAriaLabel: dismissButtonAriaLabel
    }, bannerStrings.bannerTitle && /*#__PURE__*/ React.createElement(MessageBarTitle, {
        styles: titleText
    }, bannerStrings.bannerTitle), /*#__PURE__*/ React.createElement(MessageBarMessage, {
        styles: messageText
    }, bannerStrings.bannerMessage), hyperlink !== undefined && /*#__PURE__*/ React.createElement(Link, {
        href: hyperlink.url,
        target: hyperlink.target || '_self',
        underline: true,
        onClick: hyperlink.actionCallback
    }, hyperlink.title));
};
export const MessageBanner = /*#__PURE__*/ React.memo(styled(BaseMessageBanner, getDefaultStyle));
function getDefaultStyle(_props) {
    const iconSize = '12px';
    return {
        root: {
            minHeight: 36
        },
        content: {
            alignItems: 'center'
        },
        text: {
            fontSize: 14,
            flexGrow: 1
        },
        titleText: {
            fontWeight: 600,
            display: 'inline-block'
        },
        messageText: {
            lineHeight: 'normal',
            display: 'inline-block'
        },
        actionStyles: {
            marginRight: '8px'
        },
        iconStyles: {
            root: {
                fontWeight: 400
            }
        },
        dismissal: {
            '& .ms-Button-icon': {
                fontSize: iconSize,
                height: iconSize,
                width: iconSize
            }
        }
    };
}
const MessageBarTitle = /*#__PURE__*/ React.memo((props)=>{
    const { children , styles  } = props;
    return /*#__PURE__*/ React.createElement("div", {
        className: mergeStyles(styles),
        "data-testid": messageBannerTitleTestId
    }, children, /*#__PURE__*/ React.createElement("span", null, "\xa0\xa0"));
});
const MessageBarMessage = /*#__PURE__*/ React.memo((props)=>{
    const { children , styles  } = props;
    return /*#__PURE__*/ React.createElement("div", {
        className: mergeStyles(styles)
    }, children);
}); // cspell:ignore uneditable customizer
